import { AppConfig, AuthRouter, OktaAuthService } from '@screentone/addon-auth-wrapper';

import env from 'utils/env';
import HeaderBarWrapper, { navigateRef } from './HeaderBar';
import packageJson from '../../../../package.json';

export const enum OKTA_ENV {
  LOCAL = 'local',
  DEV = 'dev',
  INT = 'int',
  PRD = 'prd'
}

const appConfig: AppConfig = {
  name: 'Curation',
  key: 'curation',
  env: env.OKTA_ENV,
  slack: {
    channel_name: 'Curation',
    channel_url: 'https://dowjones.slack.com/archives/C041L22CSLE'
  },
  // TODO: access the API version as well (needs to be sent from backend)
  versions: [{ name: 'Tool', version: packageJson.version }],
  // onPropertySwitch must not call updateCurrentProperty — doing so updates the auth
  // context's currentProperty immediately, causing the page to re-render and lose
  // unsaved changes before the navigation blocker has a chance to cancel it.
  // The URL change alone is enough: the auth context derives currentProperty from route params.
  onPropertySwitch: (property: string) => {
    navigateRef.current?.(`/${property}`);
  }
};

const authConfig: OktaAuthService = {
  issuer: env.OKTA_ISSUER,
  clientId: env.OKTA_CLIENT_ID,
  redirectUri: env.OKTA_REDIRECT_URI
};

const OktaRouter: FCC = ({ children }) => (
  <AuthRouter app={appConfig} authConfig={authConfig} headerBarWrapper={HeaderBarWrapper}>
    {children}
  </AuthRouter>
);

export default OktaRouter;
